// extracted by mini-css-extract-plugin
module.exports = {"EditMultipleModal":"EditMultipleModal_EditMultipleModal__1uKSd"};